module.exports = __webpack_public_path__ + "img/engagement@2x.7252512.jpg";